<template>
  <div
    class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-gray-300 ring-opacity-5 focus:outline-none"
    v-show="value"
  >
    <div class="py-1" role="menu">
      <a
        href="javascript:void(0)"
        class="bg-gray-100 text-gray-900 block px-4 py-2 text-sm"
        @click="toggleReportModal"
      >
        Report
      </a>
      <UserReportingModal
        v-if="isReportModalOpen"
        :isUserReportingModalOpen="isReportModalOpen"
        :handleUserReportingModal="handleUserReportingModal"
        :category_id="category_id"
        :cat_item_id="cat_item_id"
      />
    </div>
  </div>
</template>

<script>
import UserReportingModal from "@/components/UserReportingModal.vue";

export default {
  name: "ReportDropdown",
  components: {
    UserReportingModal,
  },
  data() {
    return {
      isReportModalOpen: false,
    };
  },
  props: {
    value: {
      required: true,
    },
    cat_item_id: {
      type: Number,
    },
    category_id: {
      type: Number,
    },
  },
  methods: {
    toggleReportModal: function () {
      this.isReportModalOpen = !this.isReportModalOpen;
    },

    handleUserReportingModal: function () {
      this.isReportModalOpen = false;
    },
  },
};
</script>